const TONGJI_ID = (process.env.REACT_APP_BAIDU_TONGJI_ID || "").trim();
let initialized = false;

export function isBaiduTongjiEnabled() {
  return Boolean(TONGJI_ID);
}

export function initBaiduTongji() {
  if (!TONGJI_ID || initialized || typeof window === "undefined") {
    return;
  }

  window._hmt = window._hmt || [];
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://hm.baidu.com/hm.js?${TONGJI_ID}`;
  document.head.appendChild(script);
  initialized = true;
}

export function trackBaiduPageView(pathname, search = "") {
  if (!TONGJI_ID || typeof window === "undefined") {
    return;
  }

  initBaiduTongji();
  const page = `${pathname || "/"}${search || ""}`;
  window._hmt.push(["_trackPageview", page]);
}




// var _hmt = _hmt || [];
// (function() {
//   var hm = document.createElement("script");
//   hm.src = "https://hm.baidu.com/hm.js?095f2440fe2e9ecb0e92b9a0518048a0";
//   var s = document.getElementsByTagName("script")[0];
//   s.parentNode.insertBefore(hm, s);
// })();
//
